export default __webpack_public_path__ + "static/media/FundoOpenStreet.f2af9ab7.png";